var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("billing-fields", {
        attrs: {
          countries: _vm.countries,
          address: _vm.billingAddress,
          "logged-in": _vm.loggedIn
        },
        on: {
          "ship-to-different": _vm.toggleShippingAddress,
          "country-changed": _vm.changeCountry,
          "create-account-changed": _vm.changeCreateAccount
        }
      }),
      _vm._v(" "),
      _vm.createAccount && !_vm.loggedIn
        ? _c("div", { staticClass: "flex space-x-5 mb-4" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("currency", {
        attrs: { "selected-currency": _vm.currency },
        on: { "currency-changed": _vm.changeCurrency }
      }),
      _vm._v(" "),
      _c("shipping-fields", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showShippingAddress,
            expression: "showShippingAddress"
          }
        ],
        attrs: { countries: _vm.countries, actualCountry: _vm.actualCountry },
        on: { "country-changed": _vm.changeCountry }
      }),
      _vm._v(" "),
      _vm.shippingMethods.length > 0
        ? _c("shipping-methods", {
            attrs: {
              currency: _vm.currency,
              shippingMethods: _vm.shippingMethods
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center w-1/2 border-b border-black" },
      [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "password",
            placeholder: "Heslo",
            required: "",
            name: "account_password"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center w-1/2 border-b border-black" },
      [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "password",
            placeholder: "Zopakujte heslo",
            required: "",
            name: "password_confirm"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/checkout/App.vue?vue&type=template&id=da60a768&
// module id = 149
// module chunks = 0